import localforage from 'localforage';

const ApplicationStorage = localforage.createInstance({
  name: 'Application',
});

const SearchStorage = localforage.createInstance({
  name: 'Search',
});

const SearchHistoryStorage = localforage.createInstance({
  name: 'SearchHistory',
});

const HotelReservationStorage = localforage.createInstance({
  name: 'HotelReservation',
});

const LastPurchaseHistory = localforage.createInstance({
  name: 'LastPurchase',
});

const AFStorage = localforage.createInstance({
  name: 'AppsFlyer',
});

export {
  ApplicationStorage,
  SearchStorage,
  SearchHistoryStorage,
  HotelReservationStorage,
  LastPurchaseHistory,
  AFStorage,
};
